export default "__VITE_ASSET__CxMT_EXt__";